import { animate, inView, scroll } from 'motion';

const ComparisonDetails = () => {
  const els = document.querySelectorAll('.comparison-details');

  els.forEach((el) => {
    const dotContainer = el.querySelectorAll('.dot-container');
    const dots = el.querySelectorAll('.dot');

    dotContainer.forEach((container) => {
      const line = document.createElement('div');
      let height = el.offsetHeight;

      line.classList.add(
        'bg-orange',
        'line',
        'w-[1px]',
        'h-full',
        'absolute',
        'left-1/2',
        '-translate-x-1/2',
        'origin-top'
      );

      container.appendChild(line);

      scroll(
        animate(line, {
          scaleY: [0, 1],
        }),
        {
          offset: ['0 0.75', '1 0.75'],
          target: container,
        }
      );
    });

    dots.forEach((dot) => {
      inView(
        dot,
        ({ target }) => {
          target.classList.remove('bg-white');
          target.classList.add('bg-orange');
          target.closest('.detail-container').classList.add('is-visible');

          return () => {
            target.classList.remove('bg-orange');
            target.classList.add('bg-white');
          };
        },
        {
          margin: '0px 0px -25% 0px',
        }
      );
    });
  });
};

export default ComparisonDetails;
